import { __rest } from "tslib";
import React from 'react';
import { cn } from './utils';
function BtwSkeleton(props) {
    const { className } = props, rest = __rest(props, ["className"]);
    return (React.createElement("div", Object.assign({ className: cn('animate-pulse rounded-md bg-gray-200/50', className) }, rest)));
}
export { BtwSkeleton };
